<dx-popup title="Job" [width]="400" [height]="'auto'" [(visible)]="visible" [hideOnOutsideClick]="false" (onHiding)="onHiding($event)">
    <dxi-popup-toolbar-item widget="dxButton" location="after" [options]="{ text: 'Save', type: 'success', onClick: save }">
    </dxi-popup-toolbar-item>
    <dxi-popup-toolbar-item widget="dxButton" location="after" [options]="{ text: 'Cancel', type: 'danger', onClick: cancel }">
    </dxi-popup-toolbar-item>
    <dx-form [formData]="job" validationGroup="mainValidationGroup">
        <dxi-form-item
            dataField="driverId"
            [label]="{ text: 'Driver' }"
            editorType="dxSelectBox"
            [editorOptions]="{ dataSource: drivers, valueExpr: 'userId', displayExpr: 'displayName' }"
        >
            <dxi-form-validation-rule type="required"></dxi-form-validation-rule>
        </dxi-form-item>
        <dxi-form-item dataField="driverNotes" editorType="dxTextArea" [editorOptions]="{ height: '150px' }">
            <dxi-form-validation-rule type="required"></dxi-form-validation-rule>
        </dxi-form-item>
    </dx-form>
</dx-popup>
